import { render, staticRenderFns } from "./FooterAspac.vue?vue&type=template&id=39cdd828&"
import script from "./FooterAspac.vue?vue&type=script&lang=js&"
export * from "./FooterAspac.vue?vue&type=script&lang=js&"
import style0 from "./FooterAspac.vue?vue&type=style&index=0&id=39cdd828&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports